import React from 'react';
import PropTypes from 'prop-types';
import GeneralCountBadge from 'Components/UI/Navigation/Badges/GeneralCountBadge';
import fr from 'facet-rest';
import useUserContext from 'Context/UserContext';

const InvestmentsBadge = ({ children }) => {
  const { agentResource, isLeadPlanner } = useUserContext();
  const [count, setCount] = React.useState(0);

  const getCount = async () => {
    // Only show the badge for LPs
    if (!isLeadPlanner) return;

    const countCollection = await agentResource?.relationship(fr.relationships.managedAccountModelUpdateRequestsCount.name)?.link('related').get();
    if (!countCollection) return;
    if (countCollection.resources().length() === 0) return;
    const countResource = countCollection.resources().last();
    setCount(parseInt(countResource?.attr('count'), 10));
  };
  React.useEffect(() => {
    getCount();
  }, [agentResource]);


  return (
    <GeneralCountBadge
      count={count}
    >
      {children}
    </GeneralCountBadge>
  );
};

InvestmentsBadge.propTypes = {
  children: PropTypes.node.isRequired,
};

export default InvestmentsBadge;
